import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { lazy, Suspense } from "react";
import { Toaster } from "./components/ui/sonner";

// ============================================================================
// CODE SPLITTING - Lazy load ALL page components for smaller initial bundle
// Only the route user visits gets loaded
// ============================================================================

// Critical path - StartPage orchestrator (contains Step1Page inline)
import StartPage from "./pages/StartPage";

// Lazy chunks - loaded only when user navigates to these routes
const LandingPage = lazy(() => import(/* webpackChunkName: "landing" */ "./pages/LandingPage"));
const ThankYouPage = lazy(() => import(/* webpackChunkName: "thankyou" */ "./pages/ThankYouPage"));
const AdminDashboard = lazy(() => import(/* webpackChunkName: "admin" */ "./pages/AdminDashboard"));

// Empty fallback - route transitions are fast enough
const PageLoader = () => (
  <div className="w-full max-w-lg transition-opacity duration-200 opacity-100" />
);

function App() {
  return (
    <div className="app-container">
      <BrowserRouter>
        <Suspense fallback={<PageLoader />}>
          <Routes>
            {/* Main landing page - lazy loaded */}
            <Route path="/" element={<LandingPage />} />
            
            {/* Primary intake form - critical path, loads instantly */}
            <Route path="/start" element={<StartPage />} />
            
            {/* FIX 16: Virtual quiz step URLs (all render LandingPage) */}
            <Route path="/quiz/*" element={<LandingPage />} />
            <Route path="/result/*" element={<LandingPage />} />
            <Route path="/schedule/*" element={<LandingPage />} />
            
            {/* Thank you pages */}
            <Route path="/thank-you" element={<ThankYouPage />} />
            <Route path="/thank-you/*" element={<LandingPage />} />
            
            {/* Admin Dashboard - lazy loaded */}
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
      <Toaster position="top-center" />
    </div>
  );
}

export default App;
